module.exports = __webpack_public_path__ + "img/ic_head_hight_10.d26e47df.png";